export default __webpack_public_path__ + "static/media/tcgPlayerLogo.37cb7446.png";